import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

import { useStyles } from './styles';

import * as session from '../../utils/session';
import ROUTES_NAME from '../../consts/routes-name';
import {
  FORM_LOGIN_FIELDS,
  FORM_LOGIN_LABELS,
} from '../../consts/text/form-login';
import HOME from '../../consts/text/home';
import { usePartner } from '../../context/PartnerContext';
import { AutenticationActions } from '../../store/ducks/autentication';
import { Yup } from '../../utils';
import CustomInputForm from '../CustomInputForm/CustomInputForm';

const formSchemaLogin = Yup.object().shape({
  [FORM_LOGIN_FIELDS.FIELD_EMAIL]: Yup.string().email().required(),
  [FORM_LOGIN_FIELDS.FIELD_SENHA]: Yup.string().required(),
});

export function CardLogin({
  gtm,
  tagIdEsqueciSenha,
  isNaoCorrentista,
  isSingleCard,
}) {
  const classes = useStyles({ isNaoCorrentista });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { isNotBB, areaLogadaUri } = usePartner();

  const { auth } = useSelector((state) => ({
    auth: state.autenticacao,
  }));

  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchemaLogin),
    defaultValues: {
      [FORM_LOGIN_FIELDS.FIELD_EMAIL]: '',
    },
  });
  const { errors } = formState;

  const handleChangeShowPassword = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const submitFormLogin = (_formData) => {
    session.setUserName(_formData[FORM_LOGIN_FIELDS.FIELD_EMAIL]);
    const data = {
      ..._formData,
      user_name: _formData[FORM_LOGIN_FIELDS.FIELD_EMAIL],
    };
    dispatch(AutenticationActions.postLoginRequest({ data }, areaLogadaUri));
  };

  useEffect(() => {
    if (auth?.opcaoEnvio) {
      navigate(ROUTES_NAME.VALIDACAO);
    }
  }, [auth]);

  useEffect(() => {
    setTimeout(() => resetForm(), 100);
  }, []);

  return (
    <>
      <Grid item container>
        <CustomInputForm
          checkValid
          inputRef={register}
          errors={errors}
          setValueForm={setValue}
          label={FORM_LOGIN_LABELS.LABEL_EMAIL}
          name={FORM_LOGIN_FIELDS.FIELD_EMAIL}
          data-gtm-form="input"
          data-gtm-name="email"
        />
      </Grid>

      <Grid item container>
        <CustomInputForm
          inputRef={register}
          errors={errors}
          setValueForm={setValue}
          type={showPassword ? 'text' : 'password'}
          label={FORM_LOGIN_LABELS.LABEL_SENHA}
          name={FORM_LOGIN_FIELDS.FIELD_SENHA}
          endAdornment={
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleChangeShowPassword}
              className={classes.iconeVisibility}
            >
              {showPassword ? (
                <VisibilityOutlinedIcon />
              ) : (
                <VisibilityOffOutlinedIcon />
              )}
            </IconButton>
          }
          data-gtm-form="input"
          data-gtm-name="senha"
        />
      </Grid>

      <Button
        color={isSingleCard ? 'primary' : 'secondary'}
        variant={isSingleCard ? 'outlined' : 'contained'}
        className={isSingleCard ? classes.btnAcessarSingle : classes.btnAcessar}
        disableElevation
        onClick={handleSubmit(submitFormLogin)}
        {...gtm}
        data-testid="testBtnSubmitCardLogin"
      >
        <Typography className={classes.btnAcessarText} {...gtm}>
          {!isSingleCard || isNotBB
            ? FORM_LOGIN_LABELS.BTN_ACESSAR
            : FORM_LOGIN_LABELS.BTN_CONTINUAR}
        </Typography>
      </Button>
      <Typography
        component="a"
        className={isSingleCard ? classes.linkSingle : classes.link}
        onClick={() => navigate(ROUTES_NAME.ESQUECI_SENHA)}
        data-gtm-type="click"
        data-gtm-clicktype="button"
        id={tagIdEsqueciSenha || 'esqueci-senha-001'}
        data-gtm-name="esqueci-senha"
      >
        {HOME.NAO_CORRENTISTA.ESQUECI_SENHA}
      </Typography>
    </>
  );
}
